var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP2P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.53125 11.47V13.588C3.53112 14.1443 3.64056 14.6951 3.85333 15.209C4.0661 15.7229 4.37803 16.1899 4.7713 16.5833C5.16457 16.9766 5.63148 17.2887 6.14535 17.5016C6.65923 17.7145 7.21002 17.824 7.76625 17.824H20.4712M3.53125 6.17603H16.2363C16.7926 6.17589 17.3435 6.28537 17.8575 6.4982C18.3714 6.71104 18.8385 7.02305 19.2318 7.41643C19.6252 7.8098 19.9372 8.27683 20.1501 8.79082C20.3629 9.30482 20.4724 9.85571 20.4722 10.412V12.529",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2943 14.647L20.4713 17.823L17.2943 21M6.7063 9.353L3.5293 6.176L6.7063 3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP2P);
export default __webpack_public_path__ + "static/media/_p2p.a9c0f7cfedd1e223cd79f4013cc42547.svg";
export { ForwardRef as ReactComponent };